module.exports = __webpack_public_path__ + "static/media/retractLockGuide1_Jap.3fc04799.png";